// States
export const STATUS_DRAFT = '267040000';
export const STATUS_NEW = '267040001';
export const STATUS_AWAITING_TRANSLATION = '267040002';
export const STATUS_AMENDED = '267040003';
export const STATUS_EDITED = '267040004';
export const STATUS_AWAITING_AMENDMENTS = '267040005';
export const STATUS_PUBLISHED = '267040006';
export const STATUS_ARCHIVED = '267040007';

// Actions
export const ACTION_SAVE = 'save';
export const ACTION_PUBLISH = 'publish';
export const ACTION_QA = 'qa';
export const ACTION_TRANSLATE = 'translate';

// Roles
export const ROLE_STAFF = 'Courses_CWStaff';
export const ROLE_PROVIDER = 'Courses_Provider';
export const ROLE_MANAGER = 'Courses_Manager';
export const ROLE_TRANSLATOR_MANAGER = 'Courses_TranslatorManager';
export const ROLE_TRANSLATOR = 'Courses_Translator';



// Translators
export const TRANSLATOR_ASSIGNED = 'assigned';
export const TRANSLATOR_UNASSIGNED = 'unassigned';

// Languages
export const LANGUAGE_EN = 'en';
export const LANGUAGE_CY = 'cy';

// Operations
export const OPERATION_CREATE = 'create';
export const OPERATION_EDIT = 'edit';
export const OPERATION_DUPLICATE = 'duplicate';

export const OPERATION_GROUP = 'coursesUpdateByGroup';
export const OPERATION_SELECTED = 'coursesUpdateBySelected';

export const OPERATION_TRANSLATE_DRAFT = 'translateDraft';
export const OPERATION_TRANSLATE_AMENDED = 'translateAmended';

export const STEP_MASSUPDATE_SELECT = 'select';
export const STEP_MASSUPDATE_SUBMIT = 'submit';
export const STEP_MASSUPDATE_SUCCESS = 'success';

// Tabs
export const TAB_COURSE_DETAILS = 'details';
export const TAB_COURSE_SESSIONS = 'sessions';
export const TAB_COURSE_QUALIFICATIONS = 'qualifications';
export const TAB_COURSE_CLASSIFICATIONS = 'classifications';

// Steps
export const STEP_SESSION_VIEW = 'view';
export const STEP_SESSION_CREATE = 'create';
export const STEP_SESSION_DETAILS = 'details';
export const STEP_SESSION_CONTACT = 'contact';
export const STEP_SESSION_VENUES = 'venues';
export const STEP_QUALIFICATION_VIEW = 'view';
export const STEP_QUALIFICATION_CREATE = 'create';

// Misc
export const COURSE_TITLE_FIELD_QUALIFICATION = 'qualification';
export const COURSE_TITLE_FIELD_COURSE = 'course';
